import React from 'react';
import PropTypes from 'prop-types';

import Services from "./Services";
import BlogMenu from "./BlogMenu";
import Button from "../../common/primitives/Button";

import buttons from '../../common/primitives/Button.scss';
import styles from './MainMenu.scss';

import arrowDownImg from "./img/arrow-down.png";
import arrowUpImg from "./img/arrow-up.png";
import {__t} from '../../common/lang/text-resource';

class MainMenu extends React.Component {
	state = {
		blogMenuVisible: false
	};
	toggleBlogMenu = () => {
		if (!this.props.isMobile) {
			window.location = __t("https://blog.superhosting.bg");
		} else {
			if (this.props.isMobileVisible) {
				this.setState({blogMenuVisible: !this.state.blogMenuVisible});
			}
		}
	};

	static getActiveClasses(currentPage, page, servicesVisible) {
		const urlParts = /^(?:\w+:\/\/)?([^/]+)(.*)$/.exec(currentPage);
		let path = urlParts[2];
		if (path === '/') {
			path = 'home';
		}

		if (path === page && !servicesVisible) {
			return `${styles.active} ${styles.realActive}`;
		}
		if (path === page) {
			return styles.realActive;
		}
		return '';
	}

	render() {
		const currentPage = SHVO.pageURL;
		const fullMenu =
		  <ul className={`${styles.menu} ${this.props.isMobile && this.props.isMobileVisible ? styles.mobile : null}`}>
			  <li>
				  <a href="/" title={__t("Начало")}>
					  <div className={styles.logo}>&nbsp;</div>
				  </a>
			  </li>
			  <li className={MainMenu.getActiveClasses(currentPage, 'home', this.props.isServicesVisible)}>
				  <a href="/" title={__t("Начало")}>{__t('Начало')}</a>
			  </li>
			  <li
				className={`${styles.mobileDropDownMenu} ${(this.props.isServicesVisible) ? `${styles.isVisible} ${styles.active}` : null}`}>
				  <Button
					onClick={() => this.props.toggleServices()}
					name={'do_toggle_services'}
					value={__t('Услуги')}
					className={buttons.buttonLink}/>
				  {
					  (this.props.isServicesVisible) ?
						<img src={arrowUpImg} alt={__t("Скрий")} className={styles.servicesArrow}/> :

						<img src={arrowDownImg} alt={__t("Покажи всички хостинг услуги")}
							 className={styles.servicesArrow}/>
				  }
				  {
					  (this.props.isMobile && this.props.isServicesVisible) ?
						<Services isMobile={true}/> : null
				  }
			  </li>
			  {/*<li className={MainMenu.getActiveClasses(currentPage, 'web-hosting-page-promotions.php', this.props.isServicesVisible)}>
					<a href="/web-hosting-page-promotions.php" title={__t("Промоции")}>{__t('Промоции')}</a>
				</li>*/}
			  <li
				className={MainMenu.getActiveClasses(currentPage, 'web-hosting-page-about-company.php', this.props.isServicesVisible)}>
				  <a href="/web-hosting-page-about-company.php" title={__t("За нас")}>{__t('За нас')}</a>
			  </li>
			  <li className={`${styles.mobileDropDownMenu} ${(this.state.blogMenuVisible) ? styles.isVisible : ''}`}>
				  <Button
					onClick={() => this.toggleBlogMenu()}
					name={'do_toggle_blog'}
					value={__t('Блог')}
					className={buttons.buttonLink}/>
				  {
					  (this.props.isMobile && this.state.blogMenuVisible) ? <BlogMenu/> : ''
				  }
			  </li>
			  <li>
				  <a href={__t("https://help.superhosting.bg/")} title={__t("Помощ")}>{__t('Помощ')}</a>
			  </li>
		  </ul>;

		const logoOnly =
		  <ul className={styles.menu}>
			  <li>
				  <a href="/" title={__t("Начало")}>
					  <div className={styles.logo}>&nbsp;</div>
				  </a>
			  </li>
		  </ul>;

		if (this.props.isMobile) {
			if (this.props.isMobileVisible) {
				return fullMenu;
			} else {
				return logoOnly;
			}
		}
		return fullMenu;
	}
}

MainMenu.propTypes = {
	isMobile: PropTypes.bool.isRequired,
	isMobileVisible: PropTypes.bool.isRequired,
	isServicesVisible: PropTypes.bool.isRequired,
	toggleServices: PropTypes.func.isRequired
};
export default MainMenu;